import axios from 'axios';
import { store } from '../store/store';


export const baseURLS = window.location.origin === 'https://admin.astrocall.live'
  ? 'https://api.astrocall.live/api/'
  : 'https://liveapi.astrocall.live/api/';

const axiosInstance = axios.create({
   
    baseURL: baseURLS,
});

axiosInstance.interceptors.request.use((config) => {
    const state = store.getState();
  
    const accessToken = JSON.parse(sessionStorage.getItem('accessToken'));
    const token = state.auth.auth.access_token;

    config.headers['Authorization'] = `Bearer ${accessToken}`
   
    return config;
});

export default axiosInstance;
